import {Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output} from '@angular/core';
import {SideBarService} from '@core/utils/side-bar.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'ngx-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
    @Output() onToggle = new EventEmitter();
    @Output() onElementAction = new EventEmitter();

    isOpen: boolean = false;
    suppressClickOutside: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(public sideBarService: SideBarService, private elementRef: ElementRef) {}

    /** listen for clicks outside element and close if open */
    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: any): void {
        if (!this.suppressClickOutside.getValue() && this.isOpen) {
            const clickedInside = this.elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.sideBarService.toggle();
            }
        } else {
            this.suppressClickOutside.next(false);
        }
    }

    ngOnInit(): void {
        this.sideBarService.isOpen$.subscribe((toggle: boolean, index?: number) => {
            this.toggle(toggle);
        });
        this.sideBarService.isOpenAtIndex$.subscribe((index: number) => {
            this.toggle(true, index); // always opens, stays open if open, then scrolls into view
        });
    }

    /**
     * Toggles the side bar and emits its open state
     * @param scrollIndexToView Index to scroll into view when opening (not implemented)
     */
    public toggle(open: boolean, scrollIndexToView?: number): void {
        this.suppressClickOutside.next(true);
        this.isOpen = open;
        //TODO: implement scroll element into view
        //iterate over ng-content items (we don't know the type)
        //call that item's scroll into view
        this.onToggle.emit({isOpen: this.isOpen});
    }

    // hooks for when input card has action event to be output
    public elementAction(event: any) {
        this.onElementAction.emit(event);
    }
}
